import { ColorV2 } from "config/colors";
import { toRgba } from "config/colors.rgba.logic";
import { TypographyV2 } from "config/font";
import styled from "styled-components";
import { FieldsGrid } from "../../layout/profilePanel.styled";

export const HistoryContainer = styled.div`
  padding: 0;
  background: transparent;
`;

export const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const HistoryItem = styled.div`
  border-radius: 12px;
  background: ${ColorV2.White};
`;

export const HistorySummaryRow = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  text-align: left;
`;

export const HistoryBody = styled.div<{ $expanded: boolean }>`
  max-height: ${(props) => (props.$expanded ? "2000px" : "0")};
  opacity: ${(props) => (props.$expanded ? 1 : 0)};
  overflow: hidden;
  transition:
    max-height 260ms ease,
    opacity 200ms ease;
`;

export const HistoryBodyInner = styled.div`
  margin: 10px 12px 14px;
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HistoryDetailsGrid = styled(FieldsGrid)`
  grid-template-columns: repeat(2, minmax(0, 1fr));
`;

export const SalarySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SalaryTitle = styled.h4`
  ${TypographyV2.h5}
  margin: 0;
  color: ${ColorV2.Blue1};
`;

export const SalaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SalaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: ${ColorV2.Blue7};
  border-radius: 8px;
  padding: 8px 10px;
`;

export const SalaryDate = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const SalaryValue = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
`;

export const SummaryGrid = styled.div`
  flex: 1;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
`;

export const SummaryCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const SummaryTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
`;

export const BadgeGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-self: end;
  flex-wrap: wrap;
`;

export const FutureBadge = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.DarkAmbigiousYellow};
  background: ${toRgba(ColorV2.DarkAmbigiousYellow, 0.16)};
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  min-height: 32px;
  padding: 0 16px;
  flex-shrink: 0;
`;

export const ActiveBadge = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.PositiveGreen};
  background: ${toRgba(ColorV2.PositiveGreen, 0.14)};
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  min-height: 32px;
  padding: 0 16px;
  flex-shrink: 0;
`;

export const SummaryValue = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

export const SummaryLabel = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const SummaryAction = styled.span`
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const SummaryDeleteButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 0;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  transition: opacity 140ms ease;

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    opacity: 0.65;
  }

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }
`;
